import { useEffect } from "react";
import styled from "styled-components";

import { FullPageSpinner } from "components/ui/FullPageSpinner";
import { setBootstrapStage } from "core/components/FullPageBootstrapLoader";

const FixedOverlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;
`;

const PageLoadingBar = () => {
  useEffect(() => {
    setBootstrapStage("route");
  }, []);

  return (
    <FixedOverlay>
      <FullPageSpinner />
    </FixedOverlay>
  );
};

export default PageLoadingBar;
